<template>
    <section class="footer-area bg-top pt-100 pb-70">
        <div class="container">
            <div class="row" v-if="footer">
                <div
                    class="col-lg-3 col-md-6"
                    v-for="(item, index) in footer.columnas"
                    :key="index"
                >
                    <div class="single-footer-widget">
                        <h3 v-if="item.titulo != 'title'">{{ item.titulo }}</h3>
                        <component
                            v-for="(widget, key) in item.contenido"
                            :key="key"
                            :is="loadComponent(widget.clave)"
                            :data="widget.data"
                            :config="widget.configuration"
                        ></component>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent } from "vue";
export default {
    watch: {
        lang: function (val, old) {
            if (val) {
                this.get();
            }
        },
    },
    mounted() {
        this.get();
    },
    data: function () {
        return {
            footer: null,
        };
    },
    methods: {
        get() {
            axios
                .get("/api/footer/" + this.lang.id)
                .then((response) => {
                    let decode = response.decode ?? response;
                    this.footer = decode.data;
                })
                .catch((response) => {});
        },
        loadComponent(name) {
            return defineAsyncComponent(() =>
                import(`@/default/components/${name}.vue`)
            );
        },
    },
    computed: {
        ...mapState("preferencias", ["preferencias", "contacto", "social"]),
        ...mapState("language", ["lang", "translations"]),
    },
};
</script>
